"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEventListener = exports.addEventListener = exports.getDeviceId = exports.setPushToken = exports.ping = exports.createContact = exports.valueFromTranslationErrorType = exports.allDisplayableValuesErrorType = exports.allTranslatedValuesErrorType = exports.allValuesErrorType = exports.translateErrorType = exports.ErrorType = exports.valueFromTranslationPaymentMethod = exports.allDisplayableValuesPaymentMethod = exports.allTranslatedValuesPaymentMethod = exports.allValuesPaymentMethod = exports.translatePaymentMethod = exports.PaymentMethod = exports.valueFromTranslationStateUF = exports.allDisplayableValuesStateUF = exports.allTranslatedValuesStateUF = exports.allValuesStateUF = exports.translateStateUF = exports.StateUF = exports.setStrings = exports.setUrl = exports.parseCookies = exports.isServer = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const axios_1 = require("axios");
const Cookies = require("js-cookie");
const cookie = require("cookie");
let baseUrl = "localhost:8000";
let strings = null;
exports.isServer = typeof window === "undefined";
exports.parseCookies = (req) => {
    return cookie.parse(req ? req.headers.cookie || "" : document.cookie);
};
function setUrl(url) {
    baseUrl = url;
}
exports.setUrl = setUrl;
function setStrings(newStrings) {
    strings = newStrings;
}
exports.setStrings = setStrings;
var StateUF;
(function (StateUF) {
    StateUF["AC"] = "AC";
    StateUF["AL"] = "AL";
    StateUF["AP"] = "AP";
    StateUF["AM"] = "AM";
    StateUF["BA"] = "BA";
    StateUF["CE"] = "CE";
    StateUF["DF"] = "DF";
    StateUF["ES"] = "ES";
    StateUF["GO"] = "GO";
    StateUF["MA"] = "MA";
    StateUF["MT"] = "MT";
    StateUF["MS"] = "MS";
    StateUF["MG"] = "MG";
    StateUF["PA"] = "PA";
    StateUF["PB"] = "PB";
    StateUF["PR"] = "PR";
    StateUF["PE"] = "PE";
    StateUF["PI"] = "PI";
    StateUF["RJ"] = "RJ";
    StateUF["RN"] = "RN";
    StateUF["RS"] = "RS";
    StateUF["RO"] = "RO";
    StateUF["RR"] = "RR";
    StateUF["SC"] = "SC";
    StateUF["SP"] = "SP";
    StateUF["SE"] = "SE";
    StateUF["TO"] = "TO";
})(StateUF = exports.StateUF || (exports.StateUF = {}));
function translateStateUF(enumStateUF) {
    switch (enumStateUF) {
        case StateUF.AC: {
            return strings ? strings["enum"]["StateUF"]["AC"] || StateUF.AC : StateUF.AC;
        }
        case StateUF.AL: {
            return strings ? strings["enum"]["StateUF"]["AL"] || StateUF.AL : StateUF.AL;
        }
        case StateUF.AP: {
            return strings ? strings["enum"]["StateUF"]["AP"] || StateUF.AP : StateUF.AP;
        }
        case StateUF.AM: {
            return strings ? strings["enum"]["StateUF"]["AM"] || StateUF.AM : StateUF.AM;
        }
        case StateUF.BA: {
            return strings ? strings["enum"]["StateUF"]["BA"] || StateUF.BA : StateUF.BA;
        }
        case StateUF.CE: {
            return strings ? strings["enum"]["StateUF"]["CE"] || StateUF.CE : StateUF.CE;
        }
        case StateUF.DF: {
            return strings ? strings["enum"]["StateUF"]["DF"] || StateUF.DF : StateUF.DF;
        }
        case StateUF.ES: {
            return strings ? strings["enum"]["StateUF"]["ES"] || StateUF.ES : StateUF.ES;
        }
        case StateUF.GO: {
            return strings ? strings["enum"]["StateUF"]["GO"] || StateUF.GO : StateUF.GO;
        }
        case StateUF.MA: {
            return strings ? strings["enum"]["StateUF"]["MA"] || StateUF.MA : StateUF.MA;
        }
        case StateUF.MT: {
            return strings ? strings["enum"]["StateUF"]["MT"] || StateUF.MT : StateUF.MT;
        }
        case StateUF.MS: {
            return strings ? strings["enum"]["StateUF"]["MS"] || StateUF.MS : StateUF.MS;
        }
        case StateUF.MG: {
            return strings ? strings["enum"]["StateUF"]["MG"] || StateUF.MG : StateUF.MG;
        }
        case StateUF.PA: {
            return strings ? strings["enum"]["StateUF"]["PA"] || StateUF.PA : StateUF.PA;
        }
        case StateUF.PB: {
            return strings ? strings["enum"]["StateUF"]["PB"] || StateUF.PB : StateUF.PB;
        }
        case StateUF.PR: {
            return strings ? strings["enum"]["StateUF"]["PR"] || StateUF.PR : StateUF.PR;
        }
        case StateUF.PE: {
            return strings ? strings["enum"]["StateUF"]["PE"] || StateUF.PE : StateUF.PE;
        }
        case StateUF.PI: {
            return strings ? strings["enum"]["StateUF"]["PI"] || StateUF.PI : StateUF.PI;
        }
        case StateUF.RJ: {
            return strings ? strings["enum"]["StateUF"]["RJ"] || StateUF.RJ : StateUF.RJ;
        }
        case StateUF.RN: {
            return strings ? strings["enum"]["StateUF"]["RN"] || StateUF.RN : StateUF.RN;
        }
        case StateUF.RS: {
            return strings ? strings["enum"]["StateUF"]["RS"] || StateUF.RS : StateUF.RS;
        }
        case StateUF.RO: {
            return strings ? strings["enum"]["StateUF"]["RO"] || StateUF.RO : StateUF.RO;
        }
        case StateUF.RR: {
            return strings ? strings["enum"]["StateUF"]["RR"] || StateUF.RR : StateUF.RR;
        }
        case StateUF.SC: {
            return strings ? strings["enum"]["StateUF"]["SC"] || StateUF.SC : StateUF.SC;
        }
        case StateUF.SP: {
            return strings ? strings["enum"]["StateUF"]["SP"] || StateUF.SP : StateUF.SP;
        }
        case StateUF.SE: {
            return strings ? strings["enum"]["StateUF"]["SE"] || StateUF.SE : StateUF.SE;
        }
        case StateUF.TO: {
            return strings ? strings["enum"]["StateUF"]["TO"] || StateUF.TO : StateUF.TO;
        }
    }
    return "";
}
exports.translateStateUF = translateStateUF;
function allValuesStateUF() {
    return [
        StateUF.AC,
        StateUF.AL,
        StateUF.AP,
        StateUF.AM,
        StateUF.BA,
        StateUF.CE,
        StateUF.DF,
        StateUF.ES,
        StateUF.GO,
        StateUF.MA,
        StateUF.MT,
        StateUF.MS,
        StateUF.MG,
        StateUF.PA,
        StateUF.PB,
        StateUF.PR,
        StateUF.PE,
        StateUF.PI,
        StateUF.RJ,
        StateUF.RN,
        StateUF.RS,
        StateUF.RO,
        StateUF.RR,
        StateUF.SC,
        StateUF.SP,
        StateUF.SE,
        StateUF.TO,
    ];
}
exports.allValuesStateUF = allValuesStateUF;
function allTranslatedValuesStateUF() {
    return [
        translateStateUF(StateUF.AC),
        translateStateUF(StateUF.AL),
        translateStateUF(StateUF.AP),
        translateStateUF(StateUF.AM),
        translateStateUF(StateUF.BA),
        translateStateUF(StateUF.CE),
        translateStateUF(StateUF.DF),
        translateStateUF(StateUF.ES),
        translateStateUF(StateUF.GO),
        translateStateUF(StateUF.MA),
        translateStateUF(StateUF.MT),
        translateStateUF(StateUF.MS),
        translateStateUF(StateUF.MG),
        translateStateUF(StateUF.PA),
        translateStateUF(StateUF.PB),
        translateStateUF(StateUF.PR),
        translateStateUF(StateUF.PE),
        translateStateUF(StateUF.PI),
        translateStateUF(StateUF.RJ),
        translateStateUF(StateUF.RN),
        translateStateUF(StateUF.RS),
        translateStateUF(StateUF.RO),
        translateStateUF(StateUF.RR),
        translateStateUF(StateUF.SC),
        translateStateUF(StateUF.SP),
        translateStateUF(StateUF.SE),
        translateStateUF(StateUF.TO),
    ];
}
exports.allTranslatedValuesStateUF = allTranslatedValuesStateUF;
function allDisplayableValuesStateUF() {
    return allTranslatedValuesStateUF().sort();
}
exports.allDisplayableValuesStateUF = allDisplayableValuesStateUF;
function valueFromTranslationStateUF(translation) {
    const index = allTranslatedValuesStateUF().indexOf(translation);
    return allValuesStateUF()[index] || StateUF.AC;
}
exports.valueFromTranslationStateUF = valueFromTranslationStateUF;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["pix"] = "pix";
    PaymentMethod["cash"] = "cash";
    PaymentMethod["creditCard"] = "creditCard";
    PaymentMethod["debitCard"] = "debitCard";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
function translatePaymentMethod(enumPaymentMethod) {
    switch (enumPaymentMethod) {
        case PaymentMethod.pix: {
            return strings ? strings["enum"]["PaymentMethod"]["pix"] || PaymentMethod.pix : PaymentMethod.pix;
        }
        case PaymentMethod.cash: {
            return strings ? strings["enum"]["PaymentMethod"]["cash"] || PaymentMethod.cash : PaymentMethod.cash;
        }
        case PaymentMethod.creditCard: {
            return strings ? strings["enum"]["PaymentMethod"]["creditCard"] || PaymentMethod.creditCard : PaymentMethod.creditCard;
        }
        case PaymentMethod.debitCard: {
            return strings ? strings["enum"]["PaymentMethod"]["debitCard"] || PaymentMethod.debitCard : PaymentMethod.debitCard;
        }
    }
    return "";
}
exports.translatePaymentMethod = translatePaymentMethod;
function allValuesPaymentMethod() {
    return [
        PaymentMethod.pix,
        PaymentMethod.cash,
        PaymentMethod.creditCard,
        PaymentMethod.debitCard,
    ];
}
exports.allValuesPaymentMethod = allValuesPaymentMethod;
function allTranslatedValuesPaymentMethod() {
    return [
        translatePaymentMethod(PaymentMethod.pix),
        translatePaymentMethod(PaymentMethod.cash),
        translatePaymentMethod(PaymentMethod.creditCard),
        translatePaymentMethod(PaymentMethod.debitCard),
    ];
}
exports.allTranslatedValuesPaymentMethod = allTranslatedValuesPaymentMethod;
function allDisplayableValuesPaymentMethod() {
    return allTranslatedValuesPaymentMethod().sort();
}
exports.allDisplayableValuesPaymentMethod = allDisplayableValuesPaymentMethod;
function valueFromTranslationPaymentMethod(translation) {
    const index = allTranslatedValuesPaymentMethod().indexOf(translation);
    return allValuesPaymentMethod()[index] || PaymentMethod.pix;
}
exports.valueFromTranslationPaymentMethod = valueFromTranslationPaymentMethod;
var ErrorType;
(function (ErrorType) {
    ErrorType["NotFound"] = "NotFound";
    ErrorType["MissingArgument"] = "MissingArgument";
    ErrorType["InvalidArgument"] = "InvalidArgument";
    ErrorType["InvalidPermission"] = "InvalidPermission";
    ErrorType["BadFormattedResponse"] = "BadFormattedResponse";
    ErrorType["InternalError"] = "InternalError";
    ErrorType["Validation"] = "Validation";
    ErrorType["EmailOrPasswordWrong"] = "EmailOrPasswordWrong";
    ErrorType["AccessNotAllowed"] = "AccessNotAllowed";
    ErrorType["EmailAlreadyRegistered"] = "EmailAlreadyRegistered";
    ErrorType["Fatal"] = "Fatal";
    ErrorType["Connection"] = "Connection";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
function translateErrorType(enumErrorType) {
    switch (enumErrorType) {
        case ErrorType.NotFound: {
            return strings ? strings["enum"]["ErrorType"]["NotFound"] || ErrorType.NotFound : ErrorType.NotFound;
        }
        case ErrorType.MissingArgument: {
            return strings ? strings["enum"]["ErrorType"]["MissingArgument"] || ErrorType.MissingArgument : ErrorType.MissingArgument;
        }
        case ErrorType.InvalidArgument: {
            return strings ? strings["enum"]["ErrorType"]["InvalidArgument"] || ErrorType.InvalidArgument : ErrorType.InvalidArgument;
        }
        case ErrorType.InvalidPermission: {
            return strings ? strings["enum"]["ErrorType"]["InvalidPermission"] || ErrorType.InvalidPermission : ErrorType.InvalidPermission;
        }
        case ErrorType.BadFormattedResponse: {
            return strings ? strings["enum"]["ErrorType"]["BadFormattedResponse"] || ErrorType.BadFormattedResponse : ErrorType.BadFormattedResponse;
        }
        case ErrorType.InternalError: {
            return strings ? strings["enum"]["ErrorType"]["InternalError"] || ErrorType.InternalError : ErrorType.InternalError;
        }
        case ErrorType.Validation: {
            return strings ? strings["enum"]["ErrorType"]["Validation"] || ErrorType.Validation : ErrorType.Validation;
        }
        case ErrorType.EmailOrPasswordWrong: {
            return strings ? strings["enum"]["ErrorType"]["EmailOrPasswordWrong"] || ErrorType.EmailOrPasswordWrong : ErrorType.EmailOrPasswordWrong;
        }
        case ErrorType.AccessNotAllowed: {
            return strings ? strings["enum"]["ErrorType"]["AccessNotAllowed"] || ErrorType.AccessNotAllowed : ErrorType.AccessNotAllowed;
        }
        case ErrorType.EmailAlreadyRegistered: {
            return strings ? strings["enum"]["ErrorType"]["EmailAlreadyRegistered"] || ErrorType.EmailAlreadyRegistered : ErrorType.EmailAlreadyRegistered;
        }
        case ErrorType.Fatal: {
            return strings ? strings["enum"]["ErrorType"]["Fatal"] || ErrorType.Fatal : ErrorType.Fatal;
        }
        case ErrorType.Connection: {
            return strings ? strings["enum"]["ErrorType"]["Connection"] || ErrorType.Connection : ErrorType.Connection;
        }
    }
    return "";
}
exports.translateErrorType = translateErrorType;
function allValuesErrorType() {
    return [
        ErrorType.NotFound,
        ErrorType.MissingArgument,
        ErrorType.InvalidArgument,
        ErrorType.InvalidPermission,
        ErrorType.BadFormattedResponse,
        ErrorType.InternalError,
        ErrorType.Validation,
        ErrorType.EmailOrPasswordWrong,
        ErrorType.AccessNotAllowed,
        ErrorType.EmailAlreadyRegistered,
        ErrorType.Fatal,
        ErrorType.Connection,
    ];
}
exports.allValuesErrorType = allValuesErrorType;
function allTranslatedValuesErrorType() {
    return [
        translateErrorType(ErrorType.NotFound),
        translateErrorType(ErrorType.MissingArgument),
        translateErrorType(ErrorType.InvalidArgument),
        translateErrorType(ErrorType.InvalidPermission),
        translateErrorType(ErrorType.BadFormattedResponse),
        translateErrorType(ErrorType.InternalError),
        translateErrorType(ErrorType.Validation),
        translateErrorType(ErrorType.EmailOrPasswordWrong),
        translateErrorType(ErrorType.AccessNotAllowed),
        translateErrorType(ErrorType.EmailAlreadyRegistered),
        translateErrorType(ErrorType.Fatal),
        translateErrorType(ErrorType.Connection),
    ];
}
exports.allTranslatedValuesErrorType = allTranslatedValuesErrorType;
function allDisplayableValuesErrorType() {
    return allTranslatedValuesErrorType().sort();
}
exports.allDisplayableValuesErrorType = allDisplayableValuesErrorType;
function valueFromTranslationErrorType(translation) {
    const index = allTranslatedValuesErrorType().indexOf(translation);
    return allValuesErrorType()[index] || ErrorType.NotFound;
}
exports.valueFromTranslationErrorType = valueFromTranslationErrorType;
async function createContact(newContact, options) {
    const args = {
        newContact: {
            name: newContact.name,
            email: newContact.email,
            phone: newContact.phone,
            message: newContact.message,
        },
    };
    const ret = await makeRequest({ name: "createContact", args, options });
    return {
        id: ret.id,
        name: ret.name,
        email: ret.email,
        phone: ret.phone,
        message: ret.message,
    };
}
exports.createContact = createContact;
async function ping(options) {
    const ret = await makeRequest({ name: "ping", args: {}, options });
    return ret;
}
exports.ping = ping;
async function setPushToken(token, options) {
    const args = {
        token: token,
    };
    await makeRequest({ name: "setPushToken", args, options });
    return undefined;
}
exports.setPushToken = setPushToken;
//////////////////////////////////////////////////////
let fallbackDeviceId = null;
function setDeviceId(deviceId, ctx) {
    if (!exports.isServer) {
        fallbackDeviceId = deviceId;
        try {
            Cookies.set("deviceId", deviceId);
            localStorage.setItem("deviceId", deviceId);
        }
        catch (e) { }
    }
    else {
        if (ctx) {
            ctx.deviceId = deviceId;
        }
    }
}
function getDeviceId(ctx) {
    if (!exports.isServer) {
        try {
            return localStorage.getItem("deviceId") || fallbackDeviceId;
        }
        catch (e) { }
        return fallbackDeviceId;
    }
    else {
        return ctx ? (ctx.deviceId ? ctx.deviceId : null) : null;
    }
}
exports.getDeviceId = getDeviceId;
function device(ctx) {
    let platform = null;
    if (!exports.isServer) {
        const parser = new ua_parser_js_1.UAParser();
        parser.setUA(navigator.userAgent);
        const agent = parser.getResult();
        platform = {
            browser: agent.browser.name,
            browserVersion: agent.browser.version,
            os: agent.os.name,
            osVersion: agent.os.version
        };
    }
    const device = {
        id: getDeviceId(ctx),
        type: !exports.isServer ? "web" : "ssr",
        platform: platform,
        screen: !exports.isServer ? {
            width: screen.width,
            height: screen.height
        } : null,
        version: !exports.isServer && document.currentScript ?
            document.currentScript.src :
            "",
        language: (ctx ? exports.parseCookies(ctx.req).acceptLanguage : !exports.isServer ? navigator.language : "pt-BR") || "pt-BR",
    };
    return device;
}
function randomBytesHex(len) {
    let hex = "";
    for (let i = 0; i < 2 * len; ++i)
        hex += "0123456789abcdef"[Math.floor(Math.random() * 16)];
    return hex;
}
const listenersDict = {
    fail: [],
    fatal: [],
    success: [],
};
function addEventListener(listenable, hook) {
    const listeners = listenersDict[listenable];
    listeners.push(hook);
}
exports.addEventListener = addEventListener;
function removeEventListener(listenable, hook) {
    const listeners = listenersDict[listenable];
    listenersDict[listenable] = listeners.filter(h => h !== hook);
}
exports.removeEventListener = removeEventListener;
async function makeRequest({ name, args, options }) {
    const deviceData = device(options ? options.ctx : undefined);
    if (options && options.device) {
        const device = options.device;
        if (device.id) {
            deviceData.id = device.id;
        }
        if (device.type) {
            deviceData.type = device.type;
        }
        if (device.platform) {
            deviceData.platform = device.platform;
        }
        if (device.screen) {
            deviceData.screen = device.screen;
        }
        if (device.version) {
            deviceData.version = device.version;
        }
        if (device.language) {
            deviceData.language = device.language;
        }
    }
    if (!exports.isServer) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const requestUrl = `${baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ?
                "" :
                "https://"}${baseUrl}/${name}`;
            req.open("POST", requestUrl);
            const body = {
                id: randomBytesHex(8),
                device: deviceData,
                name: name,
                args: args,
            };
            req.onreadystatechange = () => {
                if (req.readyState !== 4)
                    return;
                try {
                    const response = JSON.parse(req.responseText);
                    try {
                        setDeviceId(response.deviceId);
                        if (response.ok) {
                            resolve(response.result);
                            listenersDict["success"].forEach((hook) => hook(response.result, name, args));
                        }
                        else {
                            const error = typeof response.error === "object" ?
                                response.error :
                                { type: "Fatal", message: response.toString() };
                            reject(error);
                            listenersDict["fail"].forEach((hook) => hook(error, name, args));
                        }
                    }
                    catch (e) {
                        console.error(e);
                        reject({ type: "Fatal", message: `[${name}] ${e.toString()}` });
                        listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                    }
                }
                catch (e) {
                    console.error(e);
                    reject({ type: "BadFormattedResponse", message: `Response couldn't be parsed as JSON (${req.responseText}):\n${e.toString()}` });
                    listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                }
            };
            req.send(JSON.stringify(body));
        });
    }
    return new Promise((resolve, reject) => {
        const requestUrl = `${baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ?
            "" :
            "https://"}${baseUrl}/${name}`;
        const body = {
            id: randomBytesHex(8),
            device: deviceData,
            name: name,
            args: args
        };
        axios_1.default.post(requestUrl, body, {
            onUploadProgress: (p) => {
                if (p.loaded && p.total && options && options.progress) {
                    options.progress(Math.ceil(((p.loaded / p.total) * 100)));
                }
            },
            validateStatus: () => true,
        }).then((res) => {
            const response = res.data;
            try {
                setDeviceId(response.deviceId, options ? options.ctx : undefined);
                if (response.ok) {
                    resolve(response.result);
                    if (!exports.isServer) {
                        listenersDict["success"].forEach(hook => hook(response.result, name, args));
                    }
                }
                else {
                    const error = typeof response.error === "object" ?
                        response.error :
                        { type: "Fatal", message: response.toString() };
                    reject(error);
                    if (!exports.isServer) {
                        listenersDict["fail"].forEach((hook) => hook(error, name, args));
                    }
                }
            }
            catch (e) {
                console.error(e);
                reject({ type: "Fatal", message: `[${name}] ${e.toString()}` });
                if (!exports.isServer) {
                    listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                }
            }
        }).catch((e) => {
            console.error(e);
            reject({
                type: "BadFormattedResponse",
                message: `Response couldn't be parsed as JSON:\n${typeof e === "object" ? JSON.stringify(e) : e.toString()}`
            });
            if (!exports.isServer) {
                listenersDict["fatal"].forEach((hook) => hook(e, name, args));
            }
        });
    });
}
//# sourceMappingURL=api.js.map